<template>
  <div class="security" style="height: calc(100% - 76px);">
    <div class="user-info-card">
      <div class="user-info-content flex flex-col">
        <div class="user-info-item">
          <div class="user-info-item-tag">
            企业支付手机号
          </div>
          <div class="user-info-item-txt">
            <span>已绑定号码：{{ baseInfo.companyPay?.payPhone }}</span>

            <a v-permission="['acc:company:phone:edit']" class="cursor-pointer" @click="showEditPhoneDialog = true">立即修改</a>
          </div>
        </div>

        <div class="user-info-item">
          <div class="user-info-item-tag">
            企业支付密码
          </div>
          <div class="user-info-item-txt">
            <span>******</span>

            <a v-permission="['acc:company:pwd:reset']" class="cursor-pointer" @click="resetPassword">立即重置</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改企业支付手机号 -->
    <edit-enterprise-phone :loading="saveLoading" :visible="showEditPhoneDialog" :phone="baseInfo.companyPay?.payPhone" @close="showEditPhoneDialog = false" @confirm="confirmPhone" />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import { onConfirm } from '@vue3/components';
import EditEnterprisePhone from '../dialogs/EditEnterprisePhone.vue';
import { ElMessage } from 'element-plus';
import { resetCurEnterprisePhone, updateCurEnterprisePhone } from '@core/main';
import { useRoute } from 'vue-router';
import { ICompanyMergeInfo, IUpdateUserPhoneParam } from '@core/main/types';

defineOptions({ name: 'SecureManageTab' }); // 账户中心 - 企业管理 - 详情 - 安全管理

const route = useRoute();

const emit = defineEmits(['refresh-base-info']);

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;

const rowId = computed(() => Number(route.query.id));

const showEditPhoneDialog = ref(false);
const saveLoading = ref(false);

function resetPassword() {
  onConfirm({
    message: '确认要重置密码吗？',
    onOk: async () => {
      await resetCurEnterprisePhone(rowId.value);
      ElMessage.success('重置成功，短信已发送');
    },
  });
}

async function confirmPhone(val: IUpdateUserPhoneParam) {
  saveLoading.value = true;
  try {

    await updateCurEnterprisePhone(rowId.value, val.newPhone);
    ElMessage.success('修改成功');
    emit('refresh-base-info');
    saveLoading.value = false;

  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  showEditPhoneDialog.value = false;

}
</script>

<style lang="scss" scoped>
.security{
  @apply bg-white rounded-[2px] p-6 pr-[0] pb-[0];
}

.user-info {
  &-card {
    @apply rounded-sm bg-white w-full py-[26px] px-[24px] box-border;
  }
}

.user-info-item {
  @apply pb-[16px] mb-[24px] relative;

  border-bottom: 1px #dcdfe6 solid;

  &-tag {
    @apply text-[#344767] text-[16px] mb-[14px] font-semibold;
  }

  &-txt {
    @apply text-[#6b7891] text-[14px] flex justify-between;

    a {
      @apply text-[#409fee] hover:text-[#2b7bbd];
    }
  }
}
</style>
